import {
  IData_MagicTag_Type,
  IData_MagicTag_Type_Crm,
  IData_MagicTag_Type_Org,
} from '../types/schema/magic_tag'


export const MAGICTAG_TYPE_CRM: IData_MagicTag_Type_Crm = 'crm'
export const MAGICTAG_TYPE_ORG: IData_MagicTag_Type_Org = 'org'

export const MAGICTAG_COLORS: Record<IData_MagicTag_Type, string> = {
  [MAGICTAG_TYPE_CRM]: '#a6d4fa',
  [MAGICTAG_TYPE_ORG]: '#f6a5c0',
}

export const MAGICTAG_ROLE_CRM = 'crm:reader'
export const MAGICTAG_ROLE_ORG = 'rbac:org_viewer'

export const ENABLED_MAGIC_TAGS_TEXT_EDITOR = [
  MAGICTAG_TYPE_CRM,
  MAGICTAG_TYPE_ORG,
]

export const ENABLED_MAGIC_TAGS_LINK_EDITOR = [
  MAGICTAG_TYPE_ORG,
]

export const ENABLED_MAGIC_TAGS_ASTONISH_TEXT_EDITOR = [
  MAGICTAG_TYPE_CRM,
  MAGICTAG_TYPE_ORG,
]

export const ENABLED_MAGIC_TAGS_ASTONISH_LINK_EDITOR = [
  MAGICTAG_TYPE_ORG,
]

export const ENABLED_MAGIC_TAGS_KNOWLEDGEBASE_TEXT_EDITOR = [
  MAGICTAG_TYPE_ORG,
]

export const ENABLED_MAGIC_TAGS_KNOWLEDGEBASE_LINK_EDITOR = [
  MAGICTAG_TYPE_ORG,
]

export const ENABLED_MAGIC_TAGS_FORM_TEXT_EDITOR = [
  MAGICTAG_TYPE_ORG,
]

export const ENABLED_MAGIC_TAGS_FORM_LINK_EDITOR = [
  MAGICTAG_TYPE_ORG,
]